export const checkIfActive = (path, url) => path === url || path === `/${url}`;
